import styled, { css } from 'styled-components';

import { CommonTheme } from 'app/shared/theme';
import {
  withBackgroundCSS,
  WithBackgroundProps,
  withBorderCSS,
  WithBorderProps,
  withCursorCSS,
  WithCursorProps,
  withDimensionsCSS,
  WithDimensionsProps,
  withFlexCSS,
  WithFlexProps,
  withGridCSS,
  WithGridProps,
  withPositionCSS,
  WithPositionProps,
  withSpacingCSS,
  WithSpacingProps,
  withZIndexCSS,
  WithZIndexProps,
} from 'app/shared/components/styleUtils';

export interface GridItemProps
  extends WithSpacingProps,
    WithBorderProps,
    WithFlexProps,
    WithZIndexProps,
    WithPositionProps,
    WithBackgroundProps,
    WithCursorProps,
    WithDimensionsProps {
  mobile?: number;
  tablet?: number;
  smallDesktop?: number;
  largeDesktop?: number;
  mobileStart?: number;
  tabletStart?: number;
  smallDesktopStart?: number;
  largeDesktopStart?: number;
  rowSpan?: number;
  row?: number;
}

interface GridItemCSSProps extends GridItemProps {
  theme: CommonTheme;
}

export const GridItem = styled.div<GridItemCSSProps>`
  ${({
    theme,
    mobile = 4,
    tablet = 'auto',
    smallDesktop = 'auto',
    largeDesktop = 'auto',
    mobileStart = 'auto',
    tabletStart = 'auto',
    smallDesktopStart = 'auto',
    largeDesktopStart = 'auto',
    rowSpan,
    row,
  }) => css`
    grid-column-end: span ${mobile};
    grid-column-start: ${mobileStart};

    ${
      rowSpan &&
      !row &&
      css`
        grid-row: span ${rowSpan};
      `
    }

    ${
      row &&
      !rowSpan &&
      css`
        grid-row: ${row};
      `
    }

    ${theme.media.tablet`
      grid-column-start: ${tabletStart};
      grid-column-end: span ${tablet};
    `}

    ${theme.media.smallDesktop`
      grid-column-start: ${smallDesktopStart};
      grid-column-end: span ${smallDesktop};
    `}

    ${theme.media.largeDesktop`
      grid-column-start: ${largeDesktopStart};
      grid-column-end: span ${largeDesktop};
    `}
  `}
  ${withSpacingCSS};
  ${withFlexCSS};
  ${withBorderCSS};
  ${withPositionCSS};
  ${withZIndexCSS};
  ${withDimensionsCSS};
  ${withBackgroundCSS};
  ${withCursorCSS};
`;

// Grid
export interface GridProps
  extends WithSpacingProps,
    WithDimensionsProps,
    WithCursorProps,
    WithGridProps,
    WithBackgroundProps {}

interface GridCSSProps extends GridProps {
  theme: CommonTheme;
}

export const Grid = styled.div<GridCSSProps>`
  ${({ numberOfColumns = 12, gap = 2, ...props }) => css`
    ${withGridCSS({ numberOfColumns, gap, ...props })};
  `}

  ${withSpacingCSS};
  ${withBackgroundCSS};
  ${withDimensionsCSS};
  ${withCursorCSS};
`;
